import { render, staticRenderFns } from "./DeliveryReceptionDone.vue?vue&type=template&id=0a4bd9d8&scoped=true"
import script from "./DeliveryReceptionDone.vue?vue&type=script&lang=js"
export * from "./DeliveryReceptionDone.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a4bd9d8",
  null
  
)

export default component.exports